export default defineNuxtRouteMiddleware((to) => {
  if (process.client && to.path.startsWith('/database')) {
    const nuxtApp = useNuxtApp();
    const intercom = nuxtApp.$intercom as any;
    if (intercom && intercom.load) {
      intercom.load();
    }
  }
});
